(function() {
    'use strict';
    function MwExpansionPanelController($scope, $element, $translate, $sce) {
        var MAX_OPTION_COUNT_FOR_CHECKBOX_VIEW = 5,
            contentElement = $element.find('md-card-content'),
            expandIcon = $element.find('md-icon.expand-icon'),
            searchIcon = $element.find('md-icon.search-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.searchText = '';
        this.selectedItem = null;
        this.$translate = $translate;
        this.$sce = $sce;
        this.maxOptionCountForCheckboxView = MAX_OPTION_COUNT_FOR_CHECKBOX_VIEW;

        this.getFindBoxPlaceholderText = function getFindBoxPlaceholderText() {
            return this.$translate.instant(this.findBoxPlaceholder);
        }.bind(this);

        this.getNotFindMessage = function getNotFindMessage() {
            return this.$translate.instant('icm-search__expansion-panel--not-found-label', {searchText: this.searchText});
        }.bind(this);

        this.toggle = function toggle() {
            $element.toggleClass('active');
            contentElement.toggle();
            expandIcon.toggle();
            collapseIcon.toggle();
        };

        this.clickedClear = function clickedClear(e) {
            e.stopPropagation();

            this.searchText = '';
            this.selectedItem = null;
            this.currentSelection = {};

            if(this.clearSelection) {
                this.clearSelection();
            }
        };

        this.optionSelected = function optionSelected(item) {
            if (item) {
                return this.isSelected({option: item});
            }
            return false;
        };

        this.selectedItemChange = function selectedItemChange(item) {
            if(item) {
                if (this.singleSelection) {
                    this.selectedItem = null;
                    this.currentSelection = {};
                    this.clearSelection({ignoreSearch: true});
                }
                if (!this.optionSelected(item)) {
                    this.searchText = '';
                }
                this.selectionChanged({selectedItem: item});
            }
        };

        this.onFocus = function onFocus() {
            searchIcon.addClass('active');
        };

        this.onBlur = function onBlur() {
            if (this.searchText.length === 0) {
                searchIcon.removeClass('active');
            }
        };

        this.showSelectAll = function() {
            var show = true;

            if(this.hideShowAll || this.showCheckboxes() || this.singleSelection) {
                show = false;
            }

            return show;
        };

        this.showCheckboxes = function() {
            var show = false;

            if(this.forceCheckboxes === true) {
                show = true;
            }
            else if (this.filterName && this.filterName === 'sourcesFilter') {
                show = false;
            }
            else if(Array.isArray(this.currentOptions) && this.currentOptions.length && (this.currentOptions.length <= this.maxOptionCountForCheckboxView) && !this.singleSelection && !this.disableShortList) {
                show = true;
            }

            return show;
        };

        // need to update topFive whenever the one-way binding for current options is changed
        this.$onChanges = function (changes) {
            // determine if we should bother grabbing the top five
            // also do not want the top-five section if we are already planning on displaying checkboxes
            if((this.topFive || (changes && changes.topFive && changes.topFive.currentValue)) && !this.showCheckboxes()) {
                this.topFive = true;
            } else {
                this.topFive = false;
            }

            if(this.topFive && (changes && changes.currentOptions && changes.currentOptions.currentValue)) {
                // sort by count and grab the top 5
                this.topFiveOptions = _.sortBy(changes.currentOptions.currentValue, 'count').reverse().slice(0, 5);
            }
        };
    }

    angular
        .module('MW.ContactManager.MwExpansionPanel', [])
        .component('mwExpansionPanel', {
            bindings: {
                autoSuggest: '&',
                clearSelection: '&',
                currentOptions: '<',
                findBoxPlaceholder: '@',
                forceCheckboxes: '<',
                disableShortList: '<',
                hideAutocomplete: '<',
                hideShowAll: '<',
                isSelected: '&',
                seeAll: '&',
                currentSelection: '<',
                singleSelection: '<',
                selectionChanged: '&',
                selectionCount: '&',
                title: '@',
                filterName: '@',
                infoTip: '<',
                topFive: '<'
            },
            controller: ['$scope', '$element', '$translate', '$sce', MwExpansionPanelController],
            template: `
                <md-card>
                    <md-card-title ng-click="$ctrl.toggle()">
                        <md-card-title-text layout="row">
                            <span flex>
                                <span class="panel-title">{{$ctrl.title}}</span>
                                <mw-infotip text-content="{{$ctrl.infoTip}}"></mw-infotip>
                                <span ng-if="$ctrl.selectionCount()" class="panel-title" ng-hide="true">({{$ctrl.selectionCount()}})</span>
                                <span class="clear-selection pull-right" ng-if="$ctrl.selectionCount()" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>
                            </span>
                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>
                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>
                        </md-card-title-text>
                    </md-card-title>
                    <md-card-content ng-class="{'with-border': $ctrl.hideAutocomplete}">
                        <div class="find-box" ng-if="!$ctrl.showCheckboxes() && !$ctrl.singleSelection" ng-hide="$ctrl.hideAutocomplete">
                            <md-icon class="search-icon" md-svg-icon="action:ic_search_24px"></md-icon>
                            <md-autocomplete
                                    md-no-cache="true"
                                    md-theme="expansion-panel"
                                    md-min-length="2"
                                    md-delay="50"
                                    md-select-on-match="true"
                                    md-match-case-insensitive="true"
                                    placeholder="{{$ctrl.getFindBoxPlaceholderText()}}"
                                    md-search-text="$ctrl.searchText"
                                    md-selected-item="$ctrl.selectedItem"
                                    md-selected-item-change="$ctrl.selectedItemChange(item)"
                                    ng-focus="$ctrl.onFocus()"
                                    ng-blur="$ctrl.onBlur()"
                                    md-items="item in $ctrl.autoSuggest({searchText: $ctrl.searchText})"
                                    md-item-text="item.display">
                                <md-item-template>
                                    <span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.display}}</span>
                                </md-item-template>
                                <md-not-found>
                                    <span>{{$ctrl.getNotFindMessage()}}</span>
                                </md-not-found>
                            </md-autocomplete>
                        </div>
                        <div class="top-five checkbox-list" ng-if="$ctrl.topFive && $ctrl.topFiveOptions.length">
                            <div class="checkbox-options flex" layout="column">
                                <div ng-repeat="option in $ctrl.topFiveOptions">
                                    <md-checkbox ng-disabled='option.nonRelevant ? true : false' ng-checked="$ctrl.optionSelected(option)" aria-label="{{::option.name}}" class="md-primary" ng-click="$ctrl.selectedItemChange(option)">
                                        <span translate="{{::option.display}}"></span>
                                        <md-tooltip><span translate="{{::option.display}}"></span></md-tooltip>
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                        <div ng-if="$ctrl.showSelectAll()" class="see-all" ng-click="$ctrl.seeAll()">
                            <md-icon md-svg-icon="action:ic_list_24px"></md-icon>
                            <span translate>icm-search__filter--see-all</span>
                        </div>
                        <div class="checkbox-list" ng-if="$ctrl.showCheckboxes()">
                            <div class="checkbox-options flex" layout="column">
                                <div ng-repeat="option in $ctrl.currentOptions">
                                    <md-checkbox ng-disabled='option.nonRelevant ? true : false' ng-checked="$ctrl.optionSelected(option)" aria-label="{{::option.name}}" class="md-primary" ng-click="$ctrl.selectedItemChange(option)">
                                        <span>{{::option.display}}</span>
                                        <md-tooltip><span>{{::option.display}}</span></md-tooltip>
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="checkbox-list" ng-if="$ctrl.singleSelection">
                            <md-radio-group ng-model="$ctrl.currentSelection" class="checkbox-options flex" layout="column">
                                <md-radio-button ng-repeat="option in $ctrl.currentOptions" aria-label="{{::option.display}}" class="md-primary" ng-click="$ctrl.selectedItemChange(option)" ng-value="option.key">
                                    <span>{{::option.display}}</span>
                                    <md-tooltip>{{::option.display}}</md-tooltip>
                                </md-radio-button>
                            </md-radio-group>
                        </div>
                    </md-card-content>
                </md-card>
            `
        });
}());
